import React from "react";

const BriefCaseIcon = () => {
  return (
    <div>
      <svg
        width="39"
        height="38"
        viewBox="0 0 39 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.1157 10.9244H26.1032V8.24944C26.1032 6.77419 24.9035 5.57446 23.4282 5.57446H15.4033C13.928 5.57446 12.7283 6.77419 12.7283 8.24944V10.9244H8.71581C7.24056 10.9244 6.04083 12.1242 6.04083 13.5994V17.6119H32.7906V13.5994C32.7906 12.1242 31.5909 10.9244 30.1157 10.9244ZM15.4033 8.24944H23.4282V10.9244H15.4033V8.24944ZM22.0907 21.6243H16.7408V18.9494H6.04083V28.3118C6.04083 29.7871 7.24056 30.9868 8.71581 30.9868H30.1157C31.5909 30.9868 32.7906 29.7871 32.7906 28.3118V18.9494H22.0907V21.6243Z"
          fill="#418CFF"
        />
      </svg>
    </div>
  );
};

export default BriefCaseIcon;
